import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useDispatch, useSelector } from "react-redux";
import { addOpenDrawer } from "store/actions/appAction";
import DirectionProvider from "./DirectionProvider";
import CurrencyDrawer from "components/Shared/Drawer/CurrencyDrawer";
import AppThemeProvider from "./AppThemeProvider";
import MobileSidebar from "components/public/MobileSidebar";
import ChequeDrawer from "components/Shared/Drawer/ChequeDrawer";
import FactorDrawer from "components/Shared/Drawer/FactorDrawer";
import TransactionDrawer from "components/Shared/Drawer/TransactionDrawer";
import AccountingDrawer from "../components/Shared/Drawer/AccountingDrawer";
import RemittanceDrawer from "../components/Shared/Drawer/RemittanceDrawer";
import TransferDrawer from "../components/Shared/Drawer/TransferDrawer";
import InstallmentDrawer from "components/Shared/Drawer/InstallmentDrawer";
import useResponsive from "helpers/useResponsive";

export default function DrawerProvider() {
  const app = useSelector((state:any) => state.appReducer);
  const { isMobile } = useResponsive();

  const { isDrawerOpen, drawerComponent, anchor } = app;
  const style = app?.drawerProps?.style;

  const dispatch: any = useDispatch();

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    dispatch(addOpenDrawer(open, undefined, anchor));
  };
  return (
    <DirectionProvider>
      <div onClick={(e) => e.preventDefault()}>
        <React.Fragment>
          <Drawer anchor={anchor || "right"} open={isDrawerOpen} onClose={toggleDrawer(false)}>
            <AppThemeProvider>
              <Box
                sx={{
                  minWidth: 400,
                  maxWidth: "100vw",
                  direction: "rtl",
                  ...style,
                }}
              >
                {drawerComponent === "currencyDrawer" && <CurrencyDrawer />}
                {drawerComponent === "sidebarDrawer" && <MobileSidebar />}
                {drawerComponent === "chequeDrawer" && <ChequeDrawer />}
                {drawerComponent === "factorDrawer" && <FactorDrawer />}
                {drawerComponent === "transactionDrawer" && <TransactionDrawer />}
                {drawerComponent === "accountingDrawer" && <AccountingDrawer />}
                {drawerComponent === "remittanceDrawer" && <RemittanceDrawer />}
                {drawerComponent === "transferDrawer" && <TransferDrawer />}
                {drawerComponent === "installmentDrawer" && <InstallmentDrawer />}
              </Box>
            </AppThemeProvider>
          </Drawer>
        </React.Fragment>
      </div>
    </DirectionProvider>
  );
}
